import { render, staticRenderFns } from "./SithMesPrdZpp2MaterialsDetailList.vue?vue&type=template&id=66f496be&"
import script from "./SithMesPrdZpp2MaterialsDetailList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdZpp2MaterialsDetailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports